import React from 'react';
import { ReceiptText, UploadCloud } from 'lucide-react';

const DespesasMotoristaPlaceholder = () => {
  return (
    <div className="bg-white rounded-2xl shadow-sm p-6">
      <div className="flex items-start justify-between gap-4 flex-wrap mb-4">
        <div>
          <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2">
            <ReceiptText className="w-5 h-5 text-slate-700" />
            Despesas do motorista
          </h3>
          <p className="text-sm text-slate-600 mt-1">
            Preparado para receber despesas de alimentação, hotel e combustível com comprovantes.
          </p>
        </div>
        <span className="inline-flex px-3 py-1 rounded-lg text-xs font-medium bg-amber-100 text-amber-800">
          Em breve (depende de API)
        </span>
      </div>

      <div className="overflow-x-auto border border-slate-200 rounded-xl">
        <table className="w-full">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Tipo</th>
              <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Valor</th>
              <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Comprovante</th>
              <th className="text-left py-3 px-4 text-sm font-medium text-slate-600">Observações</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-slate-100">
              <td className="py-3 px-4 text-sm text-slate-700">Combustível</td>
              <td className="py-3 px-4 text-sm text-slate-700">R$ —</td>
              <td className="py-3 px-4 text-sm text-slate-500">—</td>
              <td className="py-3 px-4 text-sm text-slate-500">Aguardando backend</td>
            </tr>
            <tr className="border-b border-slate-100">
              <td className="py-3 px-4 text-sm text-slate-700">Alimentação</td>
              <td className="py-3 px-4 text-sm text-slate-700">R$ —</td>
              <td className="py-3 px-4 text-sm text-slate-500">—</td>
              <td className="py-3 px-4 text-sm text-slate-500">Aguardando backend</td>
            </tr>
            <tr>
              <td className="py-3 px-4 text-sm text-slate-700">Hotel</td>
              <td className="py-3 px-4 text-sm text-slate-700">R$ —</td>
              <td className="py-3 px-4 text-sm text-slate-500">—</td>
              <td className="py-3 px-4 text-sm text-slate-500">Aguardando backend</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-4 p-4 rounded-xl bg-slate-50 border border-dashed border-slate-200 text-sm text-slate-600 flex items-center gap-2">
        <UploadCloud className="w-4 h-4" />
        Endpoint esperado: `GET/POST /rotas/{'{id}'}/despesas` + upload de comprovantes por despesa.
      </div>
    </div>
  );
};

export default DespesasMotoristaPlaceholder;
